<div class="p-24 h-100 w-100 flex-col persons-page">
  <div class="flex-row space-between-center header-container">
    <app-database-tabs
      (activeTabChange)="changeActiveTab($event)"
      [activeTab]="currentTab()"
      [tabs]="personPageTabs"
    ></app-database-tabs>
    <ui-button
      type="secondary"
      [text]="'PERSONS.ADD_FROM_IMAGE' | translate"
      (clickAction)="openAddPersonByImageDialog()"
    ></ui-button>
  </div>

  <div class="content-area w-100">
    @switch (currentTab()) {
      @case (personTab.saved) {
        @if (isSavedPersonsLoading()) {
          <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
        } @else {
          @if (savedPersonViewState() !== viewState.INITIAL_EMPTY) {
            <div class="flex-row gap-8 filters-wrapper">
              <ui-search
                class="search-filter"
                [formControl]="searchForm"
                [placeholder]="'PERSONS.SEARCH_FOR_PERSON' | translate"
              ></ui-search>

              <mat-select
                [formControl]="trainingStatusForm"
                class="ui-selector"
                [placeholder]="'PERSONS.TRAINING_STATUS' | translate"
              >
                <mat-option [value]="null">{{ 'COMMON.ALL' | translate }}</mat-option>
                <mat-option [value]="personTrainingStatus.Trained">{{ 'PERSONS.TRAINING_STATUS_TRAINED' | translate }}</mat-option>
                <mat-option [value]="personTrainingStatus.Untrained">{{ 'PERSONS.TRAINING_STATUS_NEEDS_TRAINING' | translate }}</mat-option>
              </mat-select>
            </div>
          }

          @switch (savedPersonViewState()) {
            @case (viewState.INITIAL_EMPTY) {
              <ui-no-data
                [imgSrc]="noData.noSaved.imgSrc"
                [title]="noData.noSaved.title | translate"
              ></ui-no-data>
            }
            @case (viewState.NO_RESULTS) {
              <ui-no-data
                [imgSrc]="noData.noResults.imgSrc"
                [title]="noData.noResults.title | translate"
              ></ui-no-data>
            }
            @case (viewState.HAS_CONTENT) {
              <div class="persons-list">
                @for (person of filteredSavedPersons(); track person.personId) {
                  <ui-person-tile
                    [ngModel]="isPersonSelected(person.personId)"
                    (ngModelChange)="updatePersonSelection(person.personId, $event)"
                    [disabled]="isPersonDeleting(person.personId)"
                    [label]="person.name"
                    [imageUrl]="getImagePath(person)"
                    [imageUrlFallback]="getImagePath(person, false)"
                    [showCheckbox]="!isPersonDeleting(person.personId)"
                    [showConfirmationStatus]="true"
                    [isConfirmed]="person.trainingStatus === personTrainingStatus.Trained"
                    [isConfirming]="isPersonConfirming(person.personId)"
                    (confirm)="openConfirmSavedPersonRecognitionDialog(person)"
                  >
                    <div class="flex-row gap-4">
                      <ui-button
                        iconClass="ui-icon-edit"
                        type="secondary"
                        [rounded]="true"
                        [matTooltip]="'COMMON.EDIT' | translate"
                        matTooltipClass="sidebar-tooltip"
                        (clickAction)="openEditPersonDialog(person)"
                      ></ui-button>
                      <ui-button
                        iconClass="ui-icon-delete"
                        type="secondary"
                        [rounded]="true"
                        [matTooltip]="'COMMON.DELETE' | translate"
                        matTooltipClass="sidebar-tooltip"
                        [disabled]="isBulkDeletingSavedPersons()"
                        (clickAction)="openBulkDeleteConfirmDialog(person)"
                      ></ui-button>
                    </div>
                  </ui-person-tile>
                }
              </div>
            }
          }
        }
      }
      @case (personTab.unsaved) {
        @if (isUnsavedPersonsLoading()) {
          <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
        } @else {
          @switch (unsavedPersonViewState()) {
            @case (viewState.INITIAL_EMPTY) {
              <ui-no-data
                [imgSrc]="noData.noUnsaved.imgSrc"
                [title]="noData.noUnsaved.title | translate"
              ></ui-no-data>
            }
            @case (viewState.HAS_CONTENT) {
              <div class="persons-list unsaved-persons-list">
                @for (person of unsavedPersons(); track person.bucketId) {
                  <ui-person-tile
                    [ngModel]="isPersonSelected(person.bucketId)"
                    (ngModelChange)="updatePersonSelection(person.bucketId, $event)"
                    [label]="person.appearances + ' recognitions'"
                    [imageUrl]="getImagePath(person)"
                    [imageUrlFallback]="getImagePath(person, false)"
                    [showConfirmationStatus]="false"
                    [class.tile-visible]="isUnsavedPersonVisible(person.bucketId)"
                    (confirm)="openConfirmRecognitionDialog(person)"
                    (imageLoaded)="onUnsavedPersonImageLoaded(person.bucketId)"
                    (imageError)="onUnsavedPersonImageError(person.bucketId)"
                  >
                    <div class="flex-row gap-4">
                      <ui-button
                        iconClass="ui-icon-add-person"
                        type="secondary"
                        [rounded]="true"
                        [matTooltip]="'PERSONS.CONFIRM_AND_SAVE' | translate"
                        matTooltipClass="sidebar-tooltip"
                        (clickAction)="openConfirmRecognitionDialog(person)"
                      ></ui-button>
                    </div>
                  </ui-person-tile>
                }
              </div>
            }
          }
        }
      }
    }
  </div>

  @if (selectedPersonsCount() > 0) {
    <ui-selected-items-snackbar
      [counter]="selectedPersonsCount()"
      [selectedText]="'PERSONS.PERSONS_SELECTED'"
      (selectAll)="selectAllDisplayedPersons()"
      (clearAll)="clearSelectedPersons()"
    >
      @if (currentTab() === personTab.saved) {
        <div class="flex-row gap-8">
          <ui-button
            [text]="'PERSONS.ADD_TO_GROUP' | translate"
            type="secondary"
            [disabled]="isBulkDeletingSavedPersons()"
            (clickAction)="openAddPersonToGroupsDialog()"
          ></ui-button>
          <ui-button
            [text]="'COMMON.DELETE' | translate"
            type="secondary"
            [disabled]="isBulkDeletingSavedPersons()"
            [loading]="isBulkDeletingSavedPersons()"
            (clickAction)="openBulkDeleteConfirmDialog()"
          ></ui-button>
        </div>
      } @else {
        <div class="flex-row gap-8">
          <ui-button
            [text]="'PERSONS.SAVE_PERSON' | translate"
            type="secondary"
            [disabled]="isBulkDeletingSavedPersons()"
            (clickAction)="openSavePersonsDialog()"
          ></ui-button>
        </div>
      }
    </ui-selected-items-snackbar>
  }
</div>
